/**
 * swatch-updater.js
 * Updates photo swatch backgrounds when variant options change.
 * Reads from the theme's embedded product.variants JSON.
 */
(function () {
  'use strict';

  // Build lookup: { "option1|option2|option3": "sized_image_url" }
  function buildImageMap(variants) {
    var map = {};
    variants.forEach(function (v) {
      var fi = v.featured_image;
      if (!fi || !fi.src) return;
      // Apply Shopify CDN sizing - insert _300x before extension
      var src = fi.src.replace(/(\.[^./?]+)(\?.*)?$/, '_300x$1$2');
      var key = (v.option1 || '') + '|' + (v.option2 || '') + '|' + (v.option3 || '');
      if (!map[key]) map[key] = src;
    });
    return map;
  }

  // Find the best image for a swatch given current selections
  function findImage(map, optionPos, targetValue, sel1, sel2, sel3) {
    var img, k;

    if (optionPos === 1) {
      // Wood Type swatch: show its own wood grain image
      // Try with current style selected
      img = map[targetValue + '|' + sel2 + '|' + sel3];
      if (img) return img;
      img = map[targetValue + '|' + sel2 + '|'];
      if (img) return img;
      // Any style for this wood
      for (k in map) {
        if (k.indexOf(targetValue + '|') === 0) return map[k];
      }

    } else if (optionPos === 2) {
      // Style swatch: show this style in the currently selected wood
      img = map[sel1 + '|' + targetValue + '|' + sel3];
      if (img) return img;
      img = map[sel1 + '|' + targetValue + '|'];
      if (img) return img;
      // Fallback: any wood for this style
      for (k in map) {
        if (k.split('|')[1] === targetValue) return map[k];
      }

    } else if (optionPos === 3) {
      img = map[sel1 + '|' + sel2 + '|' + targetValue];
      if (img) return img;
      for (k in map) {
        if (k.split('|')[2] === targetValue) return map[k];
      }
    }
    return null;
  }

  function updateSwatches(variantSelectsEl) {
    if (!variantSelectsEl) return;

    // Parse variant JSON embedded by the theme
    var jsonScript = variantSelectsEl.querySelector('script[type="application/json"]');
    if (!jsonScript) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); }
    catch (e) { console.warn('swatch-updater: could not parse variant JSON', e); return; }

    var imageMap = buildImageMap(variants);

    if (!Object.keys(imageMap).length) {
      console.warn('swatch-updater: no variant images found in JSON');
      return;
    }

    // Get currently selected option values from checked radio inputs
    var sel = { 1: '', 2: '', 3: '' };
    variantSelectsEl.querySelectorAll('fieldset[data-option-pos]').forEach(function (fs) {
      var pos = parseInt(fs.dataset.optionPos, 10);
      var checked = fs.querySelector('input[type="radio"]:checked');
      if (checked) sel[pos] = checked.value;
    });

    // Update every swatch label
    variantSelectsEl.querySelectorAll('fieldset[data-option-pos]').forEach(function (fs) {
      var optionPos = parseInt(fs.dataset.optionPos, 10);
      fs.querySelectorAll('label[data-swatch-value]').forEach(function (label) {
        var targetValue = label.dataset.swatchValue;
        var imgUrl = findImage(imageMap, optionPos, targetValue, sel[1], sel[2], sel[3]);
        if (imgUrl) {
          label.style.setProperty('--option-color-image', "url('" + imgUrl + "')");
          label.style.setProperty('--option-color', 'var(--bg-body)');
        }
      });
    });
  }

  // Listen for Habitat theme's variant change event
  document.addEventListener('product:variant-change', function (e) {
    var sectionId = e.detail && e.detail.sectionId;
    var el = sectionId
      ? document.querySelector('variant-selects[data-section="' + sectionId + '"]')
      : document.querySelector('variant-selects');
    updateSwatches(el);
  });

  // Initial run on page load
  function initAll() {
    document.querySelectorAll('variant-selects').forEach(function (el) {
      updateSwatches(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
